<template>
  <div class="contents-inner">
    <job-preview-content-data-outline-sp
      :update-date="environment.updateDate"
      class="mb15"
    >
      <div class="data-area pt20">
        <job-preview-content-pie-data-sp
          title="女性社員の割合"
          class="mb10"
          :value="environment.womanRate"
        />

        <job-preview-content-bar-data-sp
          title="有給取得率"
          class="mb10"
          :value="environment.ptoRate"
          :average-value="average.environment.pto"
          unit="%"
        />
      </div>

      <p class="tc">
        {{ companyName }}
      </p>
      <p class="tc">
        の働く環境についてもっと知りたい方はこちら
      </p>
      <job-preview-button title="データをすべて見る" />
    </job-preview-content-data-outline-sp>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/offer/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import JobPreviewContentDataOutlineSp from '@/components/atoms/JobPreviewContentDataOutlineSp'
import JobPreviewContentPieDataSp from '@/components/atoms/JobPreviewContentPieDataSp'
import JobPreviewContentBarDataSp from '@/components/atoms/JobPreviewContentBarDataSp'
import JobPreviewButton from '@/components/atoms/JobPreviewButton'

export default {
  components: {
    JobPreviewContentDataOutlineSp,
    JobPreviewContentPieDataSp,
    JobPreviewContentBarDataSp,
    JobPreviewButton
  },
  mixins: [jobPreviewCommon],
  props: {
    companyName: {
      type: String,
      required: true
    },
    environment: {
      type: Object,
      required: true
    }
  }
}
</script>
